import { render, staticRenderFns } from "./OutputEthicsAndConsent.vue?vue&type=template&id=8f9541ae"
import script from "./OutputEthicsAndConsent.vue?vue&type=script&lang=js"
export * from "./OutputEthicsAndConsent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports